import { Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { SidebarProvider } from '@/components/ui/sidebar'
import { ThemeProvider } from '@/contexts/ThemeContext'
import SidebarNavigation from '@/components/SidebarContent'
import Home from '@/pages/Home'
import Analytics from '@/pages/Analytics'
import AIInsights from '@/pages/AIInsights'
import Courses from '@/pages/Courses'
import Newsletters from '@/pages/Newsletters'
import Documentation from '@/pages/Documentation'
import APISpecs from '@/pages/APISpecs'
import Guides from '@/pages/Guides'
import VideoTutorials from '@/pages/VideoTutorials'
import Blogs from '@/pages/Blogs'
import Settings from '@/pages/Settings'
import Integrations from '@/pages/Integrations'
import SkillMap from '@/pages/SkillMap'
import LearningPlan from '@/pages/LearningPlan'
import Projects from '@/pages/Projects'
import TransitionAgent from '@/pages/TransitionAgent'
import ResumeBrief from '@/pages/ResumeBrief'
import OnboardingProfile from '@/pages/onboarding/Profile'
import OnboardingTrackSelection from '@/pages/onboarding/TrackSelection'

export default function App() {
  // TODO: Replace with actual user data from auth context
  const userBranch = null; // Will be fetched from user profile

  return (
    <ThemeProvider 
      userBranch={userBranch}
    >
      <SidebarProvider>
        <Routes>
          {/* Onboarding routes - no sidebar */}
          <Route path="/onboarding" element={<OnboardingProfile />} />
          <Route path="/onboarding/track" element={<OnboardingTrackSelection />} />

          {/* Main app routes - with sidebar */}
          <Route
            path="/*"
            element={
              <div className="flex h-screen w-full">
                <SidebarNavigation />
                <main className="flex flex-col flex-1 min-h-0">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/skill-map" element={<SkillMap />} />
                    <Route path="/learning-plan" element={<LearningPlan />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/transition-agent" element={<TransitionAgent />} />
                    <Route path="/resume-brief" element={<ResumeBrief />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/ai-insights" element={<AIInsights />} />
                    <Route path="/courses" element={<Courses />} />
                    <Route path="/newsletters" element={<Newsletters />} />
                    <Route path="/documentation" element={<Documentation />} />
                    <Route path="/api-specs" element={<APISpecs />} />
                    <Route path="/guides" element={<Guides />} />
                    <Route path="/video-tutorials" element={<VideoTutorials />} />
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/integrations" element={<Integrations />} />
                  </Routes>
                </main>
              </div>
            }
          />
        </Routes>
        <Toaster />
      </SidebarProvider>
    </ThemeProvider>
  )
}
